import { createGlobalState } from 'react-use';

export const useFiltersGlobalState = createGlobalState({});
